<template>
  <div id="terms" class="flex column">
    <router-link v-if="!token" to="/" class="link color-text align-self-end">
      &lt; Regresar
    </router-link>
    <h1>TÉRMINOS Y CONDICIONES</h1>
    <p>Debe leer y aceptar los Términos y Condiciones indicados a continuación, de lo contrario, no podrá utilizar la aplicación de "Fideicomiso de Puentes Fronterizos.</p>
    <div class="card">
      <div class="card-content flex column wrap align-start justify-flex-start-sm">
        <h5>INFORMACIÓN RELEVANTE</h5>
        <p>
          Es requisito necesario para la adquisición de los productos que se ofrecen en este sitio, que lea y acepte los siguientes Términos y Condiciones que a continuación se redactan. El uso de nuestros servicios así como la compra de nuestros productos implicará que usted ha leído y aceptado los Términos y Condiciones de Uso en el presente documento. Todas los productos que son ofrecidos por nuestro sitio web pudieran ser creadas, cobradas, enviadas o presentadas por una página web tercera y en tal caso estarían sujetas a sus propios Términos y Condiciones. En algunos casos, para adquirir un producto, será necesario el registro por parte del usuario, con ingreso de datos personales fidedignos y definición de una contraseña.
        </p> <br/>
        <p>
          El usuario puede elegir y cambiar la clave para su acceso de administración de la cuenta en cualquier momento, en caso de que se haya registrado y que sea necesario para la compra de alguno de nuestros productos. no asume la responsabilidad en caso de que entregue dicha clave a terceros.
        </p> <br/>
        <p>
          Todas las compras y transacciones que se lleven a cabo por medio de este sitio web, están sujetas a un proceso de confirmación y verificación, el cual podría incluir la verificación del stock y disponibilidad de producto, validación de la forma de pago, validación de la factura (en caso de existir) y el cumplimiento de las condiciones requeridas por el medio de pago seleccionado. En algunos casos puede que se requiera una verificación por medio de correo electrónico.
        </p> <br/>
        <p>
          Los precios de los productos ofrecidos en esta Tienda Online es válido solamente en las compras realizadas en este sitio web.
        </p>

      </div>
      <div class="card-content flex column wrap align-start justify-flex-start-sm">
        <h5>LICENCIA</h5>
        <p>
          a través de su sitio web concede una licencia para que los usuarios utilicen los productos que son vendidos en este sitio web de acuerdo a los Términos y Condiciones que se describen en este documento.
        </p>
      </div>
      <div class="card-content flex column wrap align-start justify-flex-start-sm">
        <h5>USO NO AUTORIZADO</h5>
        <p>
          En caso de que aplique (para venta de software, templetes, u otro producto de diseño y programación) usted no puede colocar uno de nuestros productos, modificado o sin modificar, en un CD, sitio web o ningún otro medio y ofrecerlos para la redistribución o la reventa de ningún tipo.
        </p>
      </div>
      <div class="card-content flex column wrap align-start justify-flex-start-sm">
        <h5>PROPIEDAD</h5>
        <p>
          Usted no puede declarar propiedad intelectual o exclusiva a ninguno de nuestros productos, modificado o sin modificar. Todos los productos son propiedad de los proveedores del contenido. En caso de que no se especifique lo contrario, nuestros productos se proporcionan sin ningún tipo de garantía, expresa o implícita. En ningún esta compañía será responsables de ningún daño incluyendo, pero no limitado a, daños directos, indirectos, especiales, fortuitos o consecuentes u otras pérdidas resultantes del uso o de la imposibilidad de utilizar nuestros productos.
        </p>
      </div>
      <div class="card-content flex column wrap align-start justify-flex-start-sm">
        <h5>POLÍTICA DE REEMBOLSO Y GARANTÍA</h5>
        <p>
          En el caso de productos que sean mercancías irrevocables no-tangibles, no realizamos reembolsos después de que se envíe el producto, usted tiene la responsabilidad de entender antes de comprarlo. Le pedimos que lea cuidadosamente antes de comprarlo. Hacemos solamente excepciones con esta regla cuando la descripción no se ajusta al producto. Hay algunos productos que pudieran tener garantía y posibilidad de reembolso pero este será especificado al comprar el producto. En tales casos la garantía solo cubrirá fallas de fábrica y sólo se hará efectiva cuando el producto se haya usado correctamente. La garantía no cubre averías o daños ocasionados por uso indebido. Los términos de la garantía están asociados a fallas de fabricación y funcionamiento en condiciones normales de los productos y sólo se harán efectivos estos términos si el equipo ha sido usado correctamente. Esto incluye:
        </p>
        <ul>
        <li>De acuerdo a las especificaciones técnicas indicadas para cada producto. </li>
        <li>En condiciones ambientales acorde con las especificaciones indicadas por el fabricante.</li>
        <li>En uso específico para la función con que fue diseñado de fábrica. </li>
        <li>En condiciones de operación eléctricas acorde con las especificaciones y tolerancias indicadas. </li>
        </ul>
      </div>
      <div class="card-content flex column wrap align-start justify-flex-start-sm">
        <h5>COMPROBACIÓN ANTIFRAUDE</h5>
        <p>
          La compra del cliente puede ser aplazada para la comprobación antifraude. También puede ser suspendida por más tiempo para una investigación más rigurosa, para evitar transacciones fraudulentas.
        </p>
      </div>
      <div class="card-content flex column wrap align-start justify-flex-start-sm">
        <h5>PRIVACIDAD</h5>
        <p>
          Este garantiza que la información personal que usted envía cuenta con la seguridad necesaria. Los datos ingresados por usuario o en el caso de requerir una validación de los pedidos no serán entregados a terceros, salvo que deba ser revelada en cumplimiento a una orden judicial o requerimientos legales.
        </p> <br/>
        <p>
        La suscripción a boletines de correos electrónicos publicitarios es voluntaria y podría ser seleccionada al momento de crear su cuenta. Reserva los derechos de cambiar o de modificar estos términos sin previo aviso.
        </p>
      </div>
    </div>
    <div v-if="token" class="flex justify-center justify-space-evenly-sm login-buttons">
      <button @click.prevent="showModal = true" class="btn cancel">Cancelar</button>
      <button @click.prevent="acceptTerms" class="btn accept">Aceptar</button>
    </div>
    <ConfirmationModal
      @confirm="performLogout"
      @cancel="showModal = false"
      :active="showModal"
      confirmText="Cerrar Sesión"
      message="No podrás utilizar el sistema sin aceptar los Términos y Condiciones."
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import request from '@/api/request'
import ConfirmationModal from '@/components/ConfirmationModal'

export default {
  name: 'TermsAndConditions',
  data () {
    return {
      showModal: false,
      showModalError: false
    }
  },
  components: {
    ConfirmationModal
  },
  computed: {
    ...mapGetters([
      'token'
    ])
  },
  methods: {
    ...mapActions('user', [
      'logout'
    ]),
    async performLogout () {
      await this.logout()
      this.$router.push('/')
    },
    acceptTerms () {
      request({
        url: 'users/tos',
        method: 'put'
      }).then(response => {
        this.$router.push('/vehicles')
      }).catch()
    },
    goBack () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#terms {
  color: $grey;
  height: 100vh;
  text-align: left;
  margin: 0 3rem;
}

.link {
  margin-top: 2rem;
  text-decoration: none;
  color: $light-blue;
}

.card {
  background-color: $white;
  border-radius: 25px;
  height: 60vh;
  overflow-y: scroll;
}

.card-content{
  margin: 0 2rem;
  text-align: start;
}

.btn {
  font-size: 0.75rem;
  border-radius: 20px;
  color: white;
  border: 1px solid $light-blue;
  padding: 0.75rem 1.5rem;
  margin: .75rem 2rem;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }

  &.cancel {
    background-color: $light-grey;
    color: $light-blue;
  }

  &.accept {
    background-color: $light-blue;
  }
}

@media screen and (max-width: 30rem) {
  #terms {
    height: auto;
    min-height: 550px;
    overflow: scroll;
  }

  .card {
    margin: 1rem 0;
  }

  .btn {
    margin: .75rem 1rem;
  }

  h1 {
    margin: .5rem 0;
  }
}
</style>
